/**
 * return whether or not variable passed is a function
 * @param {*} fn variable to test be tested
 * @returns {boolean} whether or not variable passed is a function
 */
export default function(fn) {
    return (fn && fn.apply && fn.call) && fn;
}
